import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { NoticesSearchRequest, NoticesSimpleQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

/**
 * Simplified notices query for select components and lightweight usage.
 * Returns only essential fields: guid, name, procurementStage.
 * Does not include signals or other heavy fields.
 */
const NOTICES_SIMPLE_QUERY = graphql(`
  query noticesSimple($request: NoticesSearchRequest!) {
    notices(NoticesSearchRequest: $request) {
      totalResults
      results {
        guid
        name
        procurementStage {
          id
          stage
        }
      }
    }
  }
`);

export function useNoticesSimple(
  request: NoticesSearchRequest,
  options?: UseQueryOptions<NoticesSimpleQuery, unknown, NoticesSimpleQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["noticesSimple", request],
    NOTICES_SIMPLE_QUERY,
    [{ request }],
    {
      staleTime: 1000 * 60 * 60, // 1 hour
      ...options,
    },
  );

  return {
    data: data?.notices,
    ...rest,
  };
}
